import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';

// Models
import { ProductsData } from 'src/app/modules/products/models/products';
import { ScreenLoaderData } from 'src/app/platform/components/ui-screen-loader/ui-screen-loader.model';
import { accountStatus } from 'src/app/modules/account/models/user';

// Services
import { UiService } from 'src/app/platform/services/ui.service';
import { ProductsService } from 'src/app/modules/products/products.service';
import { ListExportService } from 'src/app/platform/services/platform.service';

// Dialogs
import { ProductsAddComponent } from 'src/app/modules/products/views/products-add/products-add.component';
import { ProductsDeleteComponent } from 'src/app/modules/products/views/products-delete/products-delete.component';
import { ProductsChangeComponent } from 'src/app/modules/products/views/products-change/products-change.component';


@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
  public filters: any = {
    type: '',
    status: '',
    date: { start: '', end: ''},
    dateExpiration: { start: '', end: ''}
  };
  public products: ProductsData[] = [];
  public productsTotal = 0;
  public productsPage = 1;
  public productsPageSize = 5;
  public productsUpdating = false;
  public productsInitStatus = false;
  public errors = {
    load: new ScreenLoaderData('Cargando productos', 'Estamos buscando todos tus productos contratados.', 'verified', true),
    empty: new ScreenLoaderData('No existen productos contratados en tu cuenta', 'Aún no contrataste ningún producto. Cuando contrates uno prodras verlo reflejado aqui.', 'help_outline'),
    error: new ScreenLoaderData('Ocurrió un error al intentar cargar los productos', 'No pudimos obtener tus productos, estamos trabajando para solucionar este problema. Por favor intenta revisar nuevamente mas tarde.', 'highlight_off'),
  };

  constructor(
    private uiService: UiService,
    private uiDialog: MatDialog,
    private dialog: MatDialog,
    private productsService: ProductsService,
    private listExportService: ListExportService,
  ) {
    this.productsService.contractsIsUpdate.subscribe((status) => {
      if (status) {
        this.productsChange();
      }
    });
  }

  ngOnInit(): void {
    this.uiService.screenLoaderSet(this.errors.load);

    this.productsLoad(this.productsPage, this.productsPageSize).then((success) => {
      if (success.registersTotal > 0) {
        this.productsInitStatus = true;
        this.products = success.registers;
        this.productsTotal = success.registersTotal;
        this.productsPage = success.page;
      } else {
        this.uiService.screenLoaderSet(this.errors.empty);
      }
    }).catch((error) => {
      this.uiService.screenLoaderSet(this.errors.error);
    });
  }

  private productsLoad(page: number | null = null, limit: number | null = null, filters: any | null = null): Promise<any> {
    return new Promise((resolve, reject) => {
      this.productsService.contractsGet(page, limit, filters).then((success) => {
        resolve(success.result);
      }).catch(() => {
        reject(false);
      });
    });
  }

  private productsChange(): void {
    this.productsUpdating = true;

    this.productsLoad(this.productsPage, this.productsPageSize, this.filters).then((success) => {
      this.productsUpdating = false;

      if (success.registersTotal > 0) {
        this.products = success.registers;
        this.productsTotal = success.registersTotal;
        this.productsPage = success.page;
      } else {
        this.products = [];
      }
    }).catch((error) => {
      this.productsUpdating = false;
      this.products = [];
      this.uiService.showSnackBar(this.errors.error.message);
    });
  }

  onPaginationChange(event: PageEvent): void {
    this.productsPage = event.pageIndex + 1;
    this.productsPageSize = event.pageSize;

    this.productsChange();
  }

  onAdd(): void {
    this.dialog.open(ProductsAddComponent, {
      width: '400px',
    });
  }

  onEdit(contract: ProductsData): void {
    this.dialog.open(ProductsChangeComponent, {
      width: '400px',
      data: {
        contract,
      }
    });
  }

  onDelete(contract: ProductsData): void {
    this.dialog.open(ProductsDeleteComponent, {
      width: '400px',
      data: {
        contract,
      }
    });
  }

  onExport(type: string): void {
    this.uiService.showSpinner(true);

    this.productsLoad(1, null, this.filters).then((success) => {
      if (success.registersTotal > 0) {
        const items: any = [];

        success.registers.forEach((item: any) => {
          items.push({
            estado: item.status,
            producto: item.product.name,
            fechaInicio: item.dateStart,
            fechaInstalacion: item.dateInstall
          });
        });

        if (items.length > 0) {
          this.uiService.showSpinner(true);

          const structure = [
            {header: 'Estado', body : 'estado'},
            {header: 'Producto', body : 'producto'},
            {header: 'Fecha de inicio', body : 'fechaInicio'},
            {header: 'Fecha de instalación', body : 'fechaInstalacion'}
          ];

          this.listExportService.downloadFile(type, 'Listado de contratos', structure, items).then((response) => {
            this.uiService.showSpinner(false);
          });
        }
      } else {
        this.uiService.showSpinner(false);
        this.uiService.showSnackBar('No existen registros para generar la exportación');
      }
    }).catch((error) => {
      this.uiService.showSpinner(false);
      this.uiService.dialogShow('Ups!', 'No es posible generar la exportación en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
    });
  }

  productsStatus(status: string): string {
    return accountStatus(status);
  }
}
